export function convertMonthsToYears(month: number) {
  return Math.floor(month / 12)
}

export function convertYearsToMonths(years: number) {
  return years * 12
}

